import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

import Carousel from "../Catalog/Carousel";
import Collection from "../Catalog/Collection";
import Item from "./Item";

const templates = {
    carousel: Carousel,
    grid: Collection
};

class BlogWidget extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            data: [],
            isLoading: true
        };

        this.fetchData = this.fetchData.bind(this);
    }
    fetchData(){
        let query = "?";

        if(this.props.filterGroups && (this.props.filterGroups instanceof Array)){
            query += `filterGroups=${JSON.stringify(this.props.filterGroups)}&`;
        }

        if(this.props.sortOrders && (this.props.sortOrders instanceof Array)){
            query += `sortOrders=${JSON.stringify(this.props.sortOrders)}&`;
        }

        if(this.props.pageSize && (typeof this.props.pageSize == "number") && this.props.pageCount && (typeof this.props.pageCount == "number")){
            query += `pageSize=${this.props.pageSize * this.props.pageCount}&`;
        }

        axios.get(`/api/blog/search${query}`)
            .then((blogResults)=>{
                this.setState({
                    data: blogResults.data.posts || [],
                    isLoading: false
                });
            }).catch((err)=>{
                console.error(err);
                this.setState({
                    isLoading: false
                });
            });
    }
    componentDidMount(){
        this.fetchData();
    }
    render(){
        const Template = templates[this.props.template];

        if(this.state.data && this.state.data.length > 0){
            return(
                <div className="blog-widget">
                    {this.props.title && (
                        <h2 className="title">{this.props.title}</h2>
                    )}
                    <Template
                        data={this.state.data}
                        itemComponent={Item}
                        pageSize={this.props.pageSize}
                        pageScroll={this.props.pageScroll}
                        loop={this.props.loop}
                        speed={this.props.speed}
                        autoPlay={this.props.autoPlay}
                        autoPlayInterval={this.props.autoPlayInterval}
                        isLoading={this.state.isLoading}
                        className="post-grid"
                    />
                </div>
            );
        } else {
            return null;
        }
    }
}

BlogWidget.defaultProps = {
    template: "grid",
    pageSize: 4,
    pageCount: 3,
    pageScroll: 4,
    autoPlay: false,
    autoPlayInterval: 3000,
    speed: 500,
    loop: true
};

BlogWidget.propTypes = {
    title: PropTypes.string,
    filterGroups: PropTypes.array,
    sortOrders: PropTypes.array,
    pageSize: PropTypes.number,
    pageCount: PropTypes.number,
    pageScroll: PropTypes.number,
    autoPlay: PropTypes.bool,
    autoPlayInterval: PropTypes.number,
    speed: PropTypes.number,
    loop: PropTypes.bool,
    template: PropTypes.string
};

export {BlogWidget};
